module.exports = __webpack_public_path__ + "img/image-357.91f100a9.jpg";